import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from 'layouts/supporter/Layout';

import {
  FileText,
  CalendarCheck,
  LifeBuoy,
  Users,
  Newspaper,
  Droplets,
  Smile,
  PenBox,
  ChartColumn
} from 'lucide-react';


interface MenuItem {
  title: string;
  url: string;
  icon?: React.ElementType;
}

const baseUrl = '/supporter';
const menuItems: MenuItem[] = [
  { title: "レスキュー作業報告", url: `${baseUrl}/rescue-report/search`, icon: LifeBuoy },
  { title: "食洗機洗浄レポート", url: `${baseUrl}/dishwasher-report`, icon: Droplets },
  { title: "覆面・満足度調査", url: `${baseUrl}/survey`, icon: Smile },
  { title: "オリジナルレポート", url: `${baseUrl}/original-report`, icon: FileText },
  { title: "レポート作成履歴", url: `${baseUrl}/report-history`, icon: ChartColumn },
  { title: "見積書作成", url: `${baseUrl}/estimate`, icon: PenBox },
  { title: "見積書作成履歴", url: `${baseUrl}/estimate-history`, icon: ChartColumn },
  { title: "訪問管理", url: `${baseUrl}/visit-management`, icon: CalendarCheck },
  { title: "NEWS", url: `${baseUrl}/news`, icon: Newspaper },
  { title: "登録情報", url: `${baseUrl}/profile`, icon: Users },
];

const Home: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="flex flex-col">
        <section className="flex flex-col justify-center flex-1">
          <div className="flex flex-col justify-center w-full max-w-3xl px-2 py-10 mx-auto sm:px-4">
            <h2 className="mb-10 text-base font-bold tracking-wide text-center text-gray-800">
              協力パートナーメニュー
            </h2>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3">
              {menuItems.map((item) => (
                <button
                  key={item.title}
                  onClick={() => navigate(item.url)}
                  className="flex flex-col items-center justify-center min-w-0 p-4 transition-all duration-200 bg-white border border-transparent shadow-xl sm:p-6 rounded-2xl hover:shadow-2xl hover:-translate-y-2 group hover:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-300"
                  style={{ maxWidth: '100%' }}
                >
                  <div className="flex items-center justify-center mb-3 rounded-full shadow-inner w-14 h-14 sm:w-16 sm:h-16 bg-gradient-to-br from-blue-50 to-blue-100 group-hover:from-blue-100 group-hover:to-blue-200">
                    {item.icon && <item.icon className="object-contain w-8 h-8 sm:w-10 sm:h-10 text-primary" />}
                  </div>
                  <span className="text-sm font-semibold text-center text-gray-700 break-words transition xs:text-base group-hover:text-blue-700">
                    {item.title}
                  </span>
                </button>
              ))}
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default Home;